import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: false
})
export class ErrorComponent {

  @Input() title = 'Error';
  @Input() header: string;
  @Input() text: string;
  @Input() errors: string[];
  @Input() isWarning = false;

  constructor(public activeModal: NgbActiveModal) {}
}
